import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';

import SectionContainer from '../SectionContainer';
import css from './SectionHero.module.css';
import { useIntl } from 'react-intl';
import { NamedLink } from '../../../../components';

// Section component for a website's hero section
// The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
    isLandingPage,
  } = props;

  const isFirstSection = isLandingPage && sectionId === 'section-1';
  const intl = useIntl();
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const firstRow = [
    {
      ...callToAction,
      href: '/l/draft/00000000-0000-0000-0000-000000000000/new/details',
      content: 'Sell a Body Shop',
    },
    {
      ...callToAction,
      href: '/l/draft/00000000-0000-0000-0000-000000000000/new/details',
      content: 'Buy a Body Shop',
    },
    {
      ...callToAction,
      href: '/l/draft/00000000-0000-0000-0000-000000000000/new/details',
      content: 'Sell Equipment',
    },
    {
      ...callToAction,
      href: '/l/draft/00000000-0000-0000-0000-000000000000/new/details',
      content: 'Buy Equipment',
    },
  ];
  const secondRow = [
    {
      ...callToAction,
      href: '/l/draft/00000000-0000-0000-0000-000000000000/new/details',
      content: 'Post a Job',
    },
    {
      ...callToAction,
      href: '/s?pub_listingType=looking-job-posting',
      content: 'Find a Job',
    },
    // {
    //   ...callToAction,
    //   href: '/s',
    //   content: 'Browse Listings',
    // },
    {
      ...callToAction,
      href: '/s',
      content: 'Miscellaneous',
    },
  ];
  const callToActionForListingType = {
    ...callToAction,
    href: '/s?pub_listingType=sell-body-shop',
    content: intl.formatMessage({ id: 'SectionHero.SectionHero.buySellButtonLabel' }),
  };
  const callToActionBuy = {
    ...callToAction,
    href: '/s?pub_listingType=purchase-body-shop',
    content: intl.formatMessage({ id: 'SectionHero.SectionHero.buyAShop' }),
  };
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          {isFirstSection ? (
            <div>
              <div className={css.buttonContainer}>
                {firstRow?.map((item, index) => (
                  <Field data={item} className={defaultClasses.ctaButton} options={fieldOptions} />
                ))}
                {/* <Field
                  data={callToAction}
                  className={defaultClasses.ctaButton}
                  options={fieldOptions}
                /> */}
              </div>
              <div className={css.buttonContainer}>
                {secondRow?.map((item, index) => (
                  <Field data={item} className={defaultClasses.ctaButton} options={fieldOptions} />
                ))}
              </div>
              <div className={css.buttonContainer}>
                <NamedLink className={css.browse} name="SearchPage" to="/s">
                  {intl.formatMessage({ id: 'SectionHero.SectionHero.browseAllListings' })}
                </NamedLink>
              </div>
            </div>
          ) : (
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          )}
        </header>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionHero.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionHero;
